import Image from 'next/image';
import { useState } from 'react';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import { ModalMobile, ModalDesktop } from '@acko-tech/building-blocks.ui.modal';
import { getCoverage, getImageBasePath } from 'utils/generics';
import { useResponsiveDevice } from 'hooks/useResponsiveDevice';
import PlanDetails from './planDetails';
import { Partners } from 'utils/constants';
import { useFetchParams } from 'hooks/useFetchParams';
import * as Styles from './styles';

interface IProps {
    planId: string;
    name: string;
    benefits: string[];
    premium: number;
    planCategory: string;
    programId: string;
    onClick: any;
    productCode?: string;
}

function PlanDetailsCard({
    planId,
    name,
    benefits,
    premium,
    planCategory,
    programId,
    onClick,
    productCode,
}: IProps) {
    const { isMobile } = useResponsiveDevice();
    const { partner } = useFetchParams();
    const [showModal, setShowModal] = useState(false);

    const Modal: any = isMobile ? ModalMobile : ModalDesktop;

    return (
        <Styles.CardWrapper>
            <Styles.PlanTitle>{name}</Styles.PlanTitle>
            {(benefits || []).map((benefit) => (
                <Styles.BenefitFlex key={benefit}>
                    <Styles.GreenTickFlex>
                        <Image
                            width={'20px'}
                            height={'20px'}
                            alt={''}
                            src={getImageBasePath('/icons/greenTick.svg')}
                        />
                    </Styles.GreenTickFlex>
                    <Styles.BenefitText>{benefit}</Styles.BenefitText>
                </Styles.BenefitFlex>
            ))}
            {/* <Styles.SeeDetails onClick={() => setShowModal(true)}>
                See Details
            </Styles.SeeDetails> */}
            <Styles.Hr />
            <Styles.BottomFlex>
                <Styles.PriceWrapper>
                    <Styles.PriceDivFlex>
                        <div style={{ display: 'flex' }}>
                            <Styles.PriceFlex>₹{premium}</Styles.PriceFlex>
                            {partner !== Partners.HERO_VIDA && (
                                <Styles.SlashYear>/ year</Styles.SlashYear>
                            )}
                        </div>
                        <Styles.GSTText>(incl 18% GST)</Styles.GSTText>
                    </Styles.PriceDivFlex>
                </Styles.PriceWrapper>
                <Styles.BuyFlex>
                    <PrimaryButton
                        size={'small'}
                        onClick={() =>
                            onClick(
                                planId,
                                name,
                                premium,
                                planCategory,
                                programId,
                                productCode
                            )
                        }
                    >
                        Select
                    </PrimaryButton>
                </Styles.BuyFlex>
            </Styles.BottomFlex>
            <Modal
                header={<></>}
                show={showModal}
                onHide={() => setShowModal(false)}
                padding={'20px'}
                wrapperStyles={`border-radius: 16px 16px 0px 0px;`}
                showOverlayBackground={true}
            >
                <PlanDetails plans={getCoverage(planCategory || '')} />
            </Modal>
        </Styles.CardWrapper>
    );
}

export default PlanDetailsCard;
